import "./App.css";
import { useLocation, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Design from "./pages/Design";
import classnames from "classnames";
import NavBar from "./NavBar";
import Safety from "./pages/Safety";
import Mission from "./pages/Mission";
import Contact from "./pages/Contact";
import BuildProgress from "./pages/BuildProgress";
import { Analytics } from "@vercel/analytics/react"

function LandingPage() {
  return (
    <>
      <NavBar />
      <Home />
      <section id="mission">
        <Mission />
      </section>
      <section id="threehalves">
        <Design />
      </section>
      <section id="safety">
        <Safety />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </>
  );
}

function App() {
  const location = useLocation();
  const darkNav = location.pathname.startsWith("/design");
  return (
    <div
      className={classnames("main", {
        dark: darkNav,
      })} >
      <Routes>
        <Route path="/buildProgress" element={<BuildProgress />} />
        <Route path="/buildprogress" element={<BuildProgress />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
      <Analytics/>
    </div>
  );
}

export default App;
